module.exports = __webpack_public_path__ + "img/I-Dont-Adventure-I-Camp.3381775b.jpg";